import React from 'react';

const IntroMuroBambooEspejo = () => {
  return (
    <section className="pb-lg-22">
      <div className="container">
        <div className="row align-items-center mt-n1-6 mt-sm-n6">
          <div className="col-lg-5 mt-1-6 mt-sm-6">
            <div className="position-relative text-center text-lg-start">
              <img 
                src="/assets/img/productos/muro-bamboo-espejo/muro-bamboo-espejo-intro.jpg" 
                alt="pisos spc en sala" 
              />
              {/* 
              <div className="position-absolute bottom-n10 right-n10 right-lg-n30 d-none d-sm-block">
                <img 
                  src="/assets/img/productos/muro-carbon-de-bambu/muro-carbon-de-bambu-intro-small.png" 
                  alt="..." 
                  style={{ width: '300px', height: '300px' }} 
                />
              </div> */}
            </div>
          </div>
          <div className="col-lg-7 mt-1-6 mt-sm-6">
            <div className="ps-lg-2-9 ps-xl-10">
              <div className="mb-1-9 mb-xl-8">
                <span className="text-primary text-uppercase small letter-spacing-4 d-block font-weight-700 mb-2">Muro interiores</span>
                <h2 className="mb-1-6 display-5 font-weight-800 lh-1">Placa Bamboo PVC Acabado Espejo</h2>
              </div>
              <div className="ps-1-9 ps-sm-10 ps-lg-20">
                <p className="mb-1-6 mb-sm-2-2">
                La Placa Bamboo PVC Acabado Espejo está fabricada con una base de carbón de bambú, resina y materiales poliméricos. 
                Su proceso de producción incluye prensado en caliente y extrusión, lo que le confiere una textura firme y resistente.<br></br>
                La superficie tipo espejo cuenta con una película de alta definición que le proporciona un acabado brillante y elegante, ideal para interiores sofisticados.
                </p>
                <a href="contacto-decototal" className="butn-style4 secondary"><span>¡Cotiza con nosotros!</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroMuroBambooEspejo;